import { fetchServiceList } from '@/api/base/index';

const SERVICE_TYPE_LIST = 'SERVICE_TYPE_LIST';
const FETCH_STATE = 'FETCH_STATE';

const state = () => ({
  lists: {
    null: [],
    1: [],
    2: [],
  },
  fetching: {
    null: false,
    1: false,
    2: false,
  },
});

const getters = {
  serviceTypeLists: state => state.lists,
};

const actions = {
  fetchServiceTypeList(
    { state, commit },
    { serviceType, serviceState, isAll }
  ) {
    if (state.fetching[serviceType]) return;
    commit(FETCH_STATE, { value: true, index: serviceType });
    return fetchServiceList({
      params: { serviceType, state: serviceState, isAll: isAll },
    }).then(res => {
      const { selfService } = res;
      commit(SERVICE_TYPE_LIST, { list: selfService, index: serviceType });
      commit(FETCH_STATE, { value: false, index: serviceType });
    });
  },
};

const mutations = {
  [SERVICE_TYPE_LIST](state, { list, index }) {
    state.lists[index] = list;
  },
  [FETCH_STATE](state, { value, index }) {
    state.fetching[index] = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
